import { Component, OnInit } from '@angular/core';
import {GlobalDataService, IsAdmin, ResetAuthToken} from '../global-data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ManageSubscriptionService} from '../manage-subscription.service';
import {AuthenticationService} from '../authentication-service.service';
import {Subscription} from '../app-models/models';

@Component({
  selector: 'app-manage-subscription',
  templateUrl: './manage-subscription.component.html',
  styleUrls: ['./manage-subscription.component.css'],
  providers: [ManageSubscriptionService]
})
export class ManageSubscriptionComponent implements OnInit {

  private id: string;
  private compObj: Subscription = new Subscription();
  private actionMessage: string;
  private actionStatus = true;

  constructor(private globalDataService: GlobalDataService, private authService: AuthenticationService,
              private router: Router, private componentService: ManageSubscriptionService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.authenticate();
  }

  authenticate(): void {
    if (this.globalDataService.token == null || !IsAdmin.call(this)) {
      this.router.navigate(['/login']);
    } else {
      this.authService.Authenticate().then(this.main.bind(this))
        .catch(this.handleAuthenticationError.bind(this));
    }
  }

  handleAuthenticationError(e) {
    ResetAuthToken.call(this);
  }

  main(result): void {
    this.route.queryParams
      .subscribe(params => {
        this.id = params['id'];
      });
    this.componentService.getData(this.id).then(this.mainSuccess.bind(this))
      .catch(this.mainFail.bind(this));
  }

  mainSuccess(result) {
    this.compObj = result;
  }

  mainFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    }
  }

  onSubmit() {
    this.actionMessage = null;
    this.componentService.editData(this.compObj).then(this.submitSuccess.bind(this))
      .catch(this.submitFail.bind(this));
  }

  submitFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    } else {
      this.actionStatus = false;
      this.actionMessage = 'Save Failed!';
    }
  }

  submitSuccess(result = null) {
    this.actionStatus = true;
    this.actionMessage = 'Success!';
  }

  onDelete() {
    this.actionMessage = null;
    this.componentService.deleteItem(this.compObj.id).then(this.deleteSuccess.bind(this))
      .catch(this.deleteFail.bind(this));
  }

  deleteFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    } else {
      this.actionStatus = false;
      this.actionMessage = 'Delete Failed!';
    }
  }

  deleteSuccess(result = null) {
    this.actionStatus = true;
    this.actionMessage = 'Success!';
  }

}



// WEBPACK FOOTER //
// ./src/app/manage-subscription/manage-subscription.component.ts